// extracted by mini-css-extract-plugin
module.exports = {"copy-content-wrapper":"InstallationMethods__copy-content-wrapper___miwu7"};